import { get, post, put } from "../httpInterceptor";

//list all tehsil district and state by pincode
export const getdetailsbypincode = (pincode) => {
  return get(`/geography/pincode/${pincode}`, null, false).then((res) => {
    console.log("saveorupdatevillagemaster", res);
    return res;
  });
};
//list of branches
export const findallbranches = () => {
  return get(`/geography/branches`).then((res) => {
    console.log("RESPONSE :: findallbranches ::: ", res);
    return res;
  });
};
//list of spokes which are not mapped with branches
export const getunmappedspokes = () => {  
  return get(`/geography/spokes/unmapped`).then((res) => {
    console.log("RESPONSE :: unmappedvillages ::: ", res);
    return res;
  });
};
export const saveorupdatebranchmaster = (obj) => {
  const endpoint = "/branch-master";
  if (obj.id) {
    // Update: Use PUT with branch ID in the endpoint
    return put(`${endpoint}/${obj.id}`, obj, false).then((res) => {
      console.log("saveorupdatebranchmaster (PUT)", res);
      return res;
    });
  } else {
    // Create: Use POST without ID
    return post(endpoint, obj, false).then((res) => {
      console.log("saveorupdatebranchmaster (POST)", res);
      return res;
    });
  }
};

//delete village by id
export const deletevillagemasterbyid = (obj) => {
  return post(`/villagemaster/deletevillagemasterbyid`, obj, false).then(
    (res) => {
      console.log("deletevillagemasterbyid", res);
      return res;
    }
  );
};

export const getRegionsByStateId = (stateId) => {
  return get(`/geography/region/${stateId}`, null, false).then((res) => {
    console.log("getRegionsByState", res);
    return res;
  });
};

// Search branches with filter
export const searchBranchesWithFilter = (filterParams) => {
  return post(`/branch-master/search`, filterParams, false).then((res) => {
    console.log("searchBranchesWithFilter", res);
    return res;
  });
};  